import { render, staticRenderFns } from "./NotificationResultTeacher.vue?vue&type=template&id=568d600c&scoped=true"
import script from "./NotificationResultTeacher.vue?vue&type=script&lang=js"
export * from "./NotificationResultTeacher.vue?vue&type=script&lang=js"
import style0 from "./NotificationResultTeacher.vue?vue&type=style&index=0&id=568d600c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d600c",
  null
  
)

export default component.exports